import * as React from 'react'
import { SVGProps } from 'react'

const SvgEmptySearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g opacity={0.2} clipPath='url(#emptySearchIcon_svg__a)'>
      <path
        d='m23.561 21.445-4.645-4.647C22.392 12.153 21.444 5.57 16.8 2.095 12.155-1.381 5.572-.433 2.096 4.21-1.38 8.856-.432 15.44 4.213 18.915a10.504 10.504 0 0 0 12.586 0l4.647 4.647a1.495 1.495 0 1 0 2.115-2.115v-.002Zm-13.016-3.427a7.474 7.474 0 1 1 7.474-7.475 7.482 7.482 0 0 1-7.474 7.475Z'
        fill='#3071EE'
      />
    </g>
    <defs>
      <clipPath id='emptySearchIcon_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgEmptySearchIcon
